import { createSelector } from 'reselect';

/**
 * Base selector to get Early Access page state
 * @param {Object} state - Redux state
 * @returns {Object} Early Access page state
 */
export const getEarlyAccessCreateUserState = state =>
  state?.earlyAccessCreateUserState;

/**
 * Selector to get the user's first name for Early Access
 * @returns {string|null} User's first name
 */
export const getEarlyAccessFirstName = createSelector(
  [getEarlyAccessCreateUserState],
  earlyAccessCreateUserState => earlyAccessCreateUserState?.firstName,
);

/**
 * Selector to get the user's last name for Early Access
 * @returns {string|null} User's last name
 */
export const getEarlyAccessLastName = createSelector(
  [getEarlyAccessCreateUserState],
  earlyAccessCreateUserState => earlyAccessCreateUserState?.lastName,
);

/**
 * Selector to get the user's username for Early Access
 * @returns {string|null} User's username
 */
export const getEarlyAccessUsername = createSelector(
  [getEarlyAccessCreateUserState],
  earlyAccessCreateUserState => earlyAccessCreateUserState?.username,
);

/**
 * Selector to get the user's password for Early Access
 * @returns {string|null} User's password
 */
export const getEarlyAccessPassword = createSelector(
  [getEarlyAccessCreateUserState],
  earlyAccessCreateUserState => earlyAccessCreateUserState?.password,
);

/**
 * Selector to get the user's associated schools for Early Access
 * @returns {string|null} User's associated schools
 */
export const getEarlyAccessAssociatedSchools = createSelector(
  [getEarlyAccessCreateUserState],
  earlyAccessCreateUserState => earlyAccessCreateUserState?.associatedSchools,
);

/**
 * Selector to get the current step in the Early Access create user form
 * @returns {number} Current step number
 */
export const getEarlyAccessCreateUserStep = createSelector(
  [getEarlyAccessCreateUserState],
  earlyAccessCreateUserState =>
    earlyAccessCreateUserState?.earlyAccessCreateUserStep,
);

export const getEarlyAccessCreateUserIsLoading = createSelector(
  [getEarlyAccessCreateUserState],
  earlyAccessCreateUserState => earlyAccessCreateUserState?.loading ?? false,
);

export const getEarlyAccessCreateUserIsErrored = createSelector(
  [getEarlyAccessCreateUserState],
  earlyAccessCreateUserState => earlyAccessCreateUserState?.error ?? false,
);

export const getEarlyAccessCreateUserHasSucceeded = createSelector(
  [getEarlyAccessCreateUserState],
  earlyAccessCreateUserState => earlyAccessCreateUserState?.success ?? false,
);
